var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15fcae5e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "base-setting-wrapper" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Name", -1 /* HOISTED */));
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Display Name", -1 /* HOISTED */));
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Type", -1 /* HOISTED */));
const _hoisted_12 = {
    key: 0,
    class: "row"
};
const _hoisted_13 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Filter Type", -1 /* HOISTED */));
const _hoisted_15 = {
    key: 1,
    class: "row"
};
const _hoisted_16 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Redirect URI", -1 /* HOISTED */));
const _hoisted_18 = {
    key: 2,
    class: "row"
};
const _hoisted_19 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Client Key URL", -1 /* HOISTED */));
const _hoisted_21 = {
    key: 3,
    class: "row"
};
const _hoisted_22 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Client Key OAuth Flow", -1 /* HOISTED */));
const _hoisted_24 = {
    key: 4,
    class: "row"
};
const _hoisted_25 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Webhook ID", -1 /* HOISTED */));
const _hoisted_27 = {
    key: 5,
    class: "row"
};
const _hoisted_28 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Options", -1 /* HOISTED */));
const _hoisted_30 = { class: "option-row" };
const _hoisted_31 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_32 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_33 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
    key: 6,
    class: "row"
};
const _hoisted_36 = { class: "text-right" };
import { computed, ref, watch } from "vue";
import { ElDialog } from "element-plus";
import Button from "../../ui/Button.vue";
import DropdownSelectorInput from "../../ui/form/DropdownSelectorInput.vue";
import { useComponentStoreV2 } from "src/shared/store/component";
import { useRouter } from "vue-router";
import notificationService from "../../ui/notification/notification-service";
import { useComponentTypes } from "src/shared/store/component-type/composables/useComponentTypes";
import { variableTypeOptions } from "src/shared/store/campaign-component/variable/model/CampaignComponentVariable";
import AllowedValuesEditor from "../drawer-common/AllowedValuesEditor.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateComponentSettingDialog',
    props: {
        componentId: {}
    },
    emits: ["closed", "created"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const router = useRouter();
        const componentStore = useComponentStoreV2();
        const isVisible = ref(true);
        const isCreating = ref(false);
        const name = ref("");
        const displayName = ref("");
        const type = ref("STRING");
        const flowId = ref("");
        const webhookId = ref("");
        const partnerOptions = ref([]);
        const filterType = ref(null);
        const redirectUri = ref("");
        const clientKeyUrl = ref("");
        const clientKeyOauthFlow = ref("");
        const allowedValues = ref([""]);
        const { componentTypes } = useComponentTypes();
        const filterTypeOptions = computed(() => {
            return componentTypes.value
                .map((type) => ({
                displayName: `${type.getDisplayName()} (${type.type})`,
                value: type.type,
            }))
                .sort((a, b) => a.displayName.localeCompare(b.displayName));
        });
        watch(() => type.value, (newType) => {
            if (newType !== "MULTI_SOCKET") {
                filterType.value = null;
            }
            if (newType !== "ENUM" && newType !== "ENUM_LIST") {
                allowedValues.value = [""];
            }
            if (newType !== "PARTNER_ENUM_LIST") {
                webhookId.value = "";
                partnerOptions.value = [{ id: "", name: "", default: "" }];
            }
        });
        const isValid = computed(() => {
            const hasName = name.value.trim() !== "";
            if (type.value === "MULTI_SOCKET") {
                return hasName && filterType.value !== null;
            }
            if (type.value === "CLIENT_KEY_FLOW") {
                return (hasName &&
                    redirectUri.value.trim() !== "" &&
                    clientKeyUrl.value.trim() !== "" &&
                    clientKeyOauthFlow.value.trim() !== "");
            }
            if (type.value === "PARTNER_ENUM_LIST") {
                return (hasName &&
                    webhookId.value.trim() !== "" &&
                    partnerOptions.value.length > 0 &&
                    partnerOptions.value.every((opt) => opt.id.trim() !== "" &&
                        opt.name.trim() !== "" &&
                        opt.default.trim() !== ""));
            }
            if (type.value === "ENUM" || type.value === "ENUM_LIST") {
                return hasName && allowedValues.value.some((v) => v.trim() !== "");
            }
            return hasName;
        });
        const addAllowedValue = () => {
            allowedValues.value.push("");
        };
        const removeAllowedValue = (index) => {
            allowedValues.value.splice(index, 1);
            if (allowedValues.value.length === 0) {
                allowedValues.value.push("");
            }
        };
        const addPartnerOption = () => {
            partnerOptions.value.push({ id: "", name: "", default: "" });
        };
        const removePartnerOption = (index) => {
            partnerOptions.value.splice(index, 1);
            if (partnerOptions.value.length === 0) {
                partnerOptions.value.push({ id: "", name: "", default: "" });
            }
        };
        const createSettingRequest = () => {
            const baseRequest = {
                name: name.value,
                display_name: displayName.value.trim() || undefined,
                type: type.value,
                tags: [],
                priority: "0",
            };
            if (type.value === "MULTI_SOCKET") {
                const socketRequest = Object.assign(Object.assign({}, baseRequest), { type: "MULTI_SOCKET", filter: { component_type: filterType.value || "" } });
                return socketRequest;
            }
            if (type.value === "CLIENT_KEY_FLOW") {
                const clientKeyFlowRequest = Object.assign(Object.assign({}, baseRequest), { type: "CLIENT_KEY_FLOW", redirect_uri: redirectUri.value, client_key_url: clientKeyUrl.value, client_key_oauth_flow: clientKeyOauthFlow.value });
                return clientKeyFlowRequest;
            }
            if (type.value === "PARTNER_ENUM_LIST") {
                const partnerEnumListRequest = Object.assign(Object.assign({}, baseRequest), { type: "PARTNER_ENUM_LIST", webhook_id: webhookId.value, options: partnerOptions.value.filter((opt) => opt.id.trim() !== "" &&
                        opt.name.trim() !== "" &&
                        opt.default.trim() !== "") });
                return partnerEnumListRequest;
            }
            if (type.value === "ENUM") {
                const enumRequest = Object.assign(Object.assign({}, baseRequest), { type: "ENUM", allowed_values: allowedValues.value.filter((v) => v.trim() !== "") });
                return enumRequest;
            }
            if (type.value === "ENUM_LIST") {
                const enumListRequest = Object.assign(Object.assign({}, baseRequest), { type: "ENUM_LIST", allowed_values: allowedValues.value.filter((v) => v.trim() !== "") });
                return enumListRequest;
            }
            if (type.value === "REWARD_SUPPLIER_ID_LIST") {
                const rewardSupplierIdListRequest = Object.assign(Object.assign({}, baseRequest), { type: "REWARD_SUPPLIER_ID_LIST", allowed_reward_supplier_ids: [] });
                return rewardSupplierIdListRequest;
            }
            return baseRequest;
        };
        const createSetting = () => __awaiter(this, void 0, void 0, function* () {
            if (!isValid.value)
                return;
            try {
                isCreating.value = true;
                const request = createSettingRequest();
                yield componentStore.createComponentSetting(props.componentId, name.value, request);
                notificationService.success("Component setting has been created");
                emit("created", name.value);
                isVisible.value = false;
            }
            catch (error) {
                notificationService.error(error);
            }
            finally {
                isCreating.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDialog), {
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((isVisible).value = $event)),
                title: "Create Setting",
                width: "500px",
                "append-to-body": true,
                "custom-class": "create-component-setting-dialog",
                onClosed: _cache[11] || (_cache[11] = ($event) => (emit('closed')))
            }, {
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_36, [
                        _createVNode(Button, {
                            level: 'secondary',
                            onClick: _cache[9] || (_cache[9] = ($event) => (isVisible.value = false))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Cancel ")
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(Button, {
                            "is-disabled": !isValid.value,
                            "is-pending": isCreating.value,
                            onClick: createSetting
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Create ")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["is-disabled", "is-pending"])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("form", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _hoisted_5,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                                        type: "text",
                                        placeholder: "Enter setting name",
                                        onKeyup: _withKeys(createSetting, ["enter"])
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, name.value]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _hoisted_8,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((displayName).value = $event)),
                                        type: "text",
                                        placeholder: "Enter display name (optional)",
                                        onKeyup: _withKeys(createSetting, ["enter"])
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, displayName.value]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _hoisted_11,
                                    _createVNode(DropdownSelectorInput, {
                                        modelValue: type.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((type).value = $event)),
                                        options: _unref(variableTypeOptions),
                                        prompt: "Select type"
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ])
                        ]),
                        (type.value === 'MULTI_SOCKET')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _hoisted_14,
                                    _createVNode(DropdownSelectorInput, {
                                        modelValue: filterType.value,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((filterType).value = $event)),
                                        options: filterTypeOptions.value,
                                        prompt: "Select filter type"
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        (type.value === 'CLIENT_KEY_FLOW')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _hoisted_17,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((redirectUri).value = $event)),
                                        type: "text",
                                        placeholder: "Enter redirect URI",
                                        onKeyup: _withKeys(createSetting, ["enter"])
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, redirectUri.value]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        (type.value === 'CLIENT_KEY_FLOW')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _hoisted_20,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((clientKeyUrl).value = $event)),
                                        type: "text",
                                        placeholder: "Enter client key URL",
                                        onKeyup: _withKeys(createSetting, ["enter"])
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, clientKeyUrl.value]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        (type.value === 'CLIENT_KEY_FLOW')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _hoisted_23,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((clientKeyOauthFlow).value = $event)),
                                        type: "text",
                                        placeholder: "Enter client key OAuth flow ID",
                                        onKeyup: _withKeys(createSetting, ["enter"])
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, clientKeyOauthFlow.value]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        (type.value === 'PARTNER_ENUM_LIST')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((webhookId).value = $event)),
                                        type: "text",
                                        placeholder: "Enter webhook ID",
                                        onKeyup: _withKeys(createSetting, ["enter"])
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, webhookId.value]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        (type.value === 'PARTNER_ENUM_LIST')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerOptions.value, (option, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "input-wrapper"
                                        }, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event) => ((option.id) = $event),
                                                    type: "text",
                                                    placeholder: 'Enter ID ' + (index + 1)
                                                }, null, 8 /* PROPS */, _hoisted_31), [
                                                    [_vModelText, option.id]
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event) => ((option.name) = $event),
                                                    type: "text",
                                                    placeholder: 'Enter name ' + (index + 1)
                                                }, null, 8 /* PROPS */, _hoisted_32), [
                                                    [_vModelText, option.name]
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event) => ((option.default) = $event),
                                                    type: "text",
                                                    placeholder: 'Enter default value (optional)'
                                                }, null, 8 /* PROPS */, _hoisted_33), [
                                                    [_vModelText, option.default]
                                                ]),
                                                (partnerOptions.value.length > 1)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "button button--secondary button--medium",
                                                        type: "button",
                                                        onClick: ($event) => (removePartnerOption(index))
                                                    }, " Remove ", 8 /* PROPS */, _hoisted_34))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    _createElementVNode("div", { class: "button-wrapper text-left" }, [
                                        _createElementVNode("button", {
                                            class: "button button--secondary button--medium",
                                            type: "button",
                                            onClick: addPartnerOption
                                        }, " + Add Option ")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        (type.value === 'ENUM' || type.value === 'ENUM_LIST')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createVNode(AllowedValuesEditor, {
                                    modelValue: allowedValues.value,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((allowedValues).value = $event))
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
